module.exports = __webpack_public_path__ + "static/img/fast-and-furious.2193697.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posters/fast-and-furious.jpg
// module id = sT6J
// module chunks = 0